export default __webpack_public_path__ + "static/lframe-pay-it-faster-eb1b5254f5d5bdea2541c9f95c6dc5a0.png";